import clsx from 'clsx'
import styles from './Section.module.css'

export default function ({ children, fullWidth, spaceY, className }) {
  return (
    <section
      className={clsx(styles.section, className, {
        [styles.sectionFullWidth]: fullWidth,
        [styles.spaceY]: spaceY,
      })}
    >
      {children}
    </section>
  )
}
